import React from "react";
import { Box, Typography, Paper } from "@mui/material";

export interface VirtualCardProps {
  cardHolderName?: string;
  cardNumber?: string;
  expiryDate?: string;
}

const VirtualCard: React.FC<VirtualCardProps> = ({
  cardHolderName = "",
  cardNumber = "•••• •••• •••• XXXX",
  expiryDate = "10/30",
}) => {
  return (
    <Paper
      sx={{
        width: "100%",
        maxWidth: 400,
        height: 240,
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        borderRadius: 3,
        p: 3,
        color: "white",
        position: "relative",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: -50,
          right: -50,
          width: 150,
          height: 150,
          background: "rgba(255, 255, 255, 0.1)",
          borderRadius: "50%",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: -80,
          left: -80,
          width: 200,
          height: 200,
          background: "rgba(255, 255, 255, 0.05)",
          borderRadius: "50%",
        },
      }}
    >
      {/* Card Number */}
      <Typography
        variant="h4"
        sx={{
          letterSpacing: "0.2em",
          fontWeight: "bold",
          mb: 3,
          textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
          position: "relative",
          zIndex: 1,
        }}
      >
        {cardNumber}
      </Typography>

      {/* Card Holder and Expiry */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          mb: 3,
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box>
          <Typography
            variant="caption"
            sx={{ opacity: 0.8, fontSize: "0.7rem" }}
          >
            Card Holder
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {cardHolderName}
          </Typography>
        </Box>
        <Box sx={{ textAlign: "right" }}>
          <Typography
            variant="caption"
            sx={{ opacity: 0.8, fontSize: "0.7rem" }}
          >
            Expires
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {expiryDate}
          </Typography>
        </Box>
      </Box>

      {/* Visa Logo */}
      <Box
        sx={{
          position: "absolute",
          bottom: 20,
          right: 20,
          zIndex: 1,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            fontStyle: "italic",
            textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
          }}
        >
          VISA
        </Typography>
      </Box>

      {/* Chip */}
      <Box
        sx={{
          position: "absolute",
          top: 20,
          left: 20,
          width: 40,
          height: 30,
          background: "linear-gradient(135deg, #ffd700, #ffec8b)",
          borderRadius: "4px",
          "&::before": {
            content: '""',
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            height: "60%",
            background: "linear-gradient(135deg, #daa520, #ffd700)",
            borderRadius: "2px",
          },
        }}
      />
    </Paper>
  );
};

export default VirtualCard;
